<div [formGroup]="group">
  <mat-checkbox class="lum-mat-component" [formControlName]="model.key" (change)="onChange()">
    <span [innerHTML]="model | lumDfRequiredAsterisk: fieldControl?.errors"></span>
  </mat-checkbox>

  <div class="mat-hint lum-df-mat-hint">
    <span [lumDynamicFormError]="fieldControl" [validText]="model.hint || '' | markdown | async"></span>
  </div>
</div>
